import axios from "axios";

import api from "../utils/axiosInterceptor";

const API_URL = process.env.REACT_APP_API_URL;

export const ReportsServices = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/reports/ratings`, data);
		return response.data;
	} catch (error) {
		console.error("Error in Address And Rating Details Function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const CommentsServices = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/reports/comments`, data);
		return response.data;
	} catch (error) {
		console.error("Error in Address And Rating Details Function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const AddressServices = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/reports/address`, data);
		return response.data;
	} catch (error) {
		console.error("Error in Address And Rating Details Function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const ContractorServices = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/reports/contractor`, data);
		return response.data;
	} catch (error) {
		console.error("Error in Address And Rating Details Function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const FilterDataServices = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/reports/filter`, data);
		return response.data;
	} catch (error) {
		console.error("Error in Address And Rating Details Function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};
